import config from '../../config/config';

export const MERCHANT_DETAILS_LOAD = 'MERCHANT_DETAILS/MERCHANT_DETAILS_LOAD';
export const MERCHANT_DETAILS_SUCCESS = 'MERCHANT_DETAILS/MERCHANT_DETAILS_SUCCESS';
export const MERCHANT_DETAILS_FAILURE = 'MERCHANT_DETAILS/MERCHANT_DETAILS_FAILURE';

export function getMerchantDetailsSuccessActionCreator(merchantDetails) {
    return {
        merchantDetails,
        type: MERCHANT_DETAILS_SUCCESS
    };
}

export function getMerchantDetailsFailureActionCreator(error) {
    return {
        error,
        type: MERCHANT_DETAILS_FAILURE
    };
}

export function getMerchantDetails(onboardingId) {
    const url = `${config.underwritingApiUrl}/onboarding/details/${onboardingId}`;

    return {
        failureActionTypeOrCreator: getMerchantDetailsFailureActionCreator,
        fetchParams: {
            url
        },
        loadActionTypeOrCreator: MERCHANT_DETAILS_LOAD,
        successActionTypeOrCreator: getMerchantDetailsSuccessActionCreator
    };
}

export const UPDATE_PENDING_LIST_ITEM_LOAD = 'MERCHANT_DETAILS/UPDATE_PENDING_LIST_ITEM_LOAD';
export const UPDATE_PENDING_LIST_ITEM_SUCCESS = 'MERCHANT_DETAILS/UPDATE_PENDING_LIST_ITEM_SUCCESS';
export const UPDATE_PENDING_LIST_ITEM_FAILURE = 'MERCHANT_DETAILS/UPDATE_PENDING_LIST_ITEM_FAILURE';

export function updatePendingListItemSuccessActionCreator() {
    return {
        type: UPDATE_PENDING_LIST_ITEM_SUCCESS
    };
}

export function updatePendingListItemFailureActionCreator(error) {
    return {
        error,
        type: UPDATE_PENDING_LIST_ITEM_FAILURE
    };
}

export function updatePendingListItem(itemId, questionResponse, documentUploads) {
    const body = {};

    if (questionResponse !== undefined) {
        body.questionResponse = questionResponse;
    }

    if (documentUploads !== undefined && Array.isArray(documentUploads)) {
        body.documentUploads = JSON.stringify(documentUploads);
    }

    return {
        failureActionTypeOrCreator: updatePendingListItemFailureActionCreator,
        fetchParams: {
            url: `${config.underwritingApiUrl}/onboarding/updatePendingListItem/${itemId}`,
            method: 'PUT',
            body
        },
        loadActionTypeOrCreator: UPDATE_PENDING_LIST_ITEM_LOAD,
        successActionTypeOrCreator: updatePendingListItemSuccessActionCreator
    };
}

export const GET_PENDING_LIST_UPLOAD_LINKS_LOAD = 'MERCHANT_DETAILS/GET_PENDING_LIST_UPLOAD_LINKS_LOAD';
export const GET_PENDING_LIST_UPLOAD_LINKS_SUCCESS = 'MERCHANT_DETAILS/GET_PENDING_LIST_UPLOAD_LINKS_SUCCESS';
export const GET_PENDING_LIST_UPLOAD_LINKS_FAILURE = 'MERCHANT_DETAILS/GET_PENDING_LIST_UPLOAD_LINKS_FAILURE';

export function getPendingListUploadLinksSuccessActionCreator(uploadLinks) {
    return {
        uploadLinks,
        type: GET_PENDING_LIST_UPLOAD_LINKS_SUCCESS
    };
}

export function getPendingListUploadLinksFailureActionCreator(error) {
    return {
        error,
        type: GET_PENDING_LIST_UPLOAD_LINKS_FAILURE
    };
}

export function getPendingListUploadLinks(itemId, filenames) {
    return {
        failureActionTypeOrCreator: getPendingListUploadLinksFailureActionCreator,
        fetchParams: {
            url: `${config.underwritingApiUrl}/onboarding/getPendingListUploadLinks/${itemId}`,
            method: 'POST',
            body: { filenames }
        },
        loadActionTypeOrCreator: GET_PENDING_LIST_UPLOAD_LINKS_LOAD,
        successActionTypeOrCreator: getPendingListUploadLinksSuccessActionCreator
    };
}

export const DELETE_PENDING_LIST_DOCUMENT_LOAD = 'MERCHANT_DETAILS/DELETE_PENDING_LIST_DOCUMENT_LOAD';
export const DELETE_PENDING_LIST_DOCUMENT_SUCCESS = 'MERCHANT_DETAILS/DELETE_PENDING_LIST_DOCUMENT_SUCCESS';
export const DELETE_PENDING_LIST_DOCUMENT_FAILURE = 'MERCHANT_DETAILS/DELETE_PENDING_LIST_DOCUMENT_FAILURE';

export function deletePendingListDocumentSuccessActionCreator() {
    return {
        type: DELETE_PENDING_LIST_DOCUMENT_SUCCESS
    };
}

export function deletePendingListDocumentFailureActionCreator(error) {
    return {
        error,
        type: DELETE_PENDING_LIST_DOCUMENT_FAILURE
    };
}

export function deletePendingListDocument(pendingListItemId, documentName) {
    return {
        failureActionTypeOrCreator: deletePendingListDocumentFailureActionCreator,
        fetchParams: {
            url: `${config.underwritingApiUrl}/onboarding/deletePendingListDocument/${pendingListItemId}?documentName=${encodeURIComponent(documentName)}`,
            method: 'DELETE'
        },
        loadActionTypeOrCreator: DELETE_PENDING_LIST_DOCUMENT_LOAD,
        successActionTypeOrCreator: deletePendingListDocumentSuccessActionCreator
    };
}

export const SUBMIT_PENDING_LIST_LOAD = 'MERCHANT_DETAILS/SUBMIT_PENDING_LIST_LOAD';
export const SUBMIT_PENDING_LIST_SUCCESS = 'MERCHANT_DETAILS/SUBMIT_PENDING_LIST_SUCCESS';
export const SUBMIT_PENDING_LIST_FAILURE = 'MERCHANT_DETAILS/SUBMIT_PENDING_LIST_FAILURE';

export function submitPendingListSuccessActionCreator() {
    return {
        type: SUBMIT_PENDING_LIST_SUCCESS
    };
}

export function submitPendingListFailureActionCreator(error) {
    return {
        error,
        type: SUBMIT_PENDING_LIST_FAILURE
    };
}

export function submitPendingList(cmcMerchantId) {
    return {
        failureActionTypeOrCreator: submitPendingListFailureActionCreator,
        fetchParams: {
            url: `${config.underwritingApiUrl}/onboarding/submitPendingList`,
            method: 'POST',
            body: { cmcMerchantId }
        },
        loadActionTypeOrCreator: SUBMIT_PENDING_LIST_LOAD,
        successActionTypeOrCreator: submitPendingListSuccessActionCreator
    };
}
export const GET_PENDING_LIST_DOWNLOAD_URLS_SUCCESS = 'MERCHANT_DETAILS/GET_PENDING_LIST_DOWNLOAD_URLS_SUCCESS';

export function getPendingListDownloadLinksSuccessActionCreator(downloadUrls, context) {
    const itemId = context?.itemId;

    return {
        downloadUrls: Array.isArray(downloadUrls) ? downloadUrls : [],
        itemId,
        type: GET_PENDING_LIST_DOWNLOAD_URLS_SUCCESS
    };
}

export function getPendingListDownloadUrls(itemId) {
    return {
        fetchParams: {
            url: `${config.underwritingApiUrl}/onboarding/getPendingListDownloadUrls/${itemId}`,
            method: 'GET'
        },
        successActionTypeOrCreator: getPendingListDownloadLinksSuccessActionCreator,
        successActionContext: { itemId }
    };
}
